import React from 'react';
import Icon from '@amzn/awsui-components-console/icon';
import type { Collection } from '@amzn/aws-gcr-content-connection-management-client';
import './CollectionCard.scss';

export interface CollectionCardProps {
  collection: Collection;
  onClick: (id: string) => void;
}

const CollectionCard: React.FC<CollectionCardProps> = ({ collection, onClick }) => {
  return (
    <div
      className="collection-card"
      onClick={() => onClick(collection.name!)}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => e.key === 'Enter' && onClick(collection.name!)}
    >
      <h3 className="collection-card__name">{collection.name}</h3>
      <p className="collection-card__description">{collection.description}</p>
      <div className="collection-card__stats">
        <span className="collection-card__stat">
          <Icon name="file" /> {(collection.itemCount || 0).toLocaleString()} Items
        </span>
        <span className="collection-card__stat">
          <Icon name="group" /> {(collection.useCases || []).length} Applications
        </span>
      </div>
    </div>
  );
};

export default CollectionCard;
